export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7914.7f5b494b.jpg";